import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { appIcon } from "../../assets/images/index";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import "./navbar.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    background: "#fff",
  },
  title: {
    flexGrow: 1,
  },
}));

function NavBar(props) {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [user, setUser] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    localStorage.clear();
    history.push("/");
    window.location.reload(false);
    handleClose();
  };
  useEffect(() => {
    setIsAuthenticated(localStorage.getItem("isAuthenticated"));
    setUser(localStorage.getItem("user"));
  }, []);
  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        className="top-nav-bar"
        color="transparent"
        elevation={0}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => history.push("/")}
          >
            <img src={appIcon} alt="app-icon" />
          </IconButton>
          <div className={classes.title}></div>
          {/*<Button color="inherit">Contractors</Button>
          <Button color="inherit">Enterprise</Button>
          <Button color="inherit">About us</Button>
          <Button color="inherit">Book Now</Button>*/}
          {localStorage.getItem("isAuthenticated") ? (
            <>
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                {localStorage.getItem("user")
                  ? localStorage.getItem("user")
                  : ""}
              </Button>

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={(e) => handleLogout(e)}>Logout</MenuItem>
              </Menu>
            </>
          ) : (
            ""
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  };
};

export default connect(mapStateToProps, null)(NavBar);
